/* ============================================================
 * edj-landing-countdown — custom element <edj-landing-countdown>
 * Compte à rebours réutilisable pour les landings BF / Drop / Honmei
 *
 * Attributs:
 *   target          (string, ISO date — ex: "2026-11-29T00:00:00+01:00")
 *   ended-text      (string, texte affiché après expiration)
 *
 * Le composant cherche en interne 4 éléments avec les data-attrs:
 *   [data-d]  → jours
 *   [data-h]  → heures
 *   [data-m]  → minutes
 *   [data-s]  → secondes
 * et met à jour leur textContent avec une valeur paddée à 2 chiffres.
 *
 * Quand le compteur expire:
 *   - tous les chiffres passent à "00"
 *   - l'attribut data-state="ended" est posé sur le host
 *   - si [data-ended] existe à l'intérieur, son texte est remplacé par ended-text
 * ============================================================ */
(function () {
  if (customElements.get('edj-landing-countdown')) return;

  class EdjLandingCountdown extends HTMLElement {
    connectedCallback() {
      this._target = this.getAttribute('target');
      if (!this._target) {
        return;
      }
      const targetDate = new Date(this._target);
      if (isNaN(targetDate.getTime())) {
        return;
      }
      this._targetMs = targetDate.getTime();
      this._d = this.querySelector('[data-d]');
      this._h = this.querySelector('[data-h]');
      this._m = this.querySelector('[data-m]');
      this._s = this.querySelector('[data-s]');
      this._endedNode = this.querySelector('[data-ended]');
      this._endedText = this.getAttribute('ended-text') || '';
      this._tick();
      this._timer = setInterval(() => this._tick(), 1000);
    }

    disconnectedCallback() {
      if (this._timer) clearInterval(this._timer);
    }

    _pad(n) {
      n = Math.max(0, n | 0);
      return n < 10 ? '0' + n : '' + n;
    }

    _tick() {
      const now = Date.now();
      let diff = this._targetMs - now;
      if (diff <= 0) {
        if (this._d) this._d.textContent = '00';
        if (this._h) this._h.textContent = '00';
        if (this._m) this._m.textContent = '00';
        if (this._s) this._s.textContent = '00';
        this.setAttribute('data-state', 'ended');
        if (this._endedNode && this._endedText) {
          this._endedNode.textContent = this._endedText;
        }
        if (this._timer) {
          clearInterval(this._timer);
          this._timer = null;
        }
        return;
      }
      const sec = Math.floor(diff / 1000);
      const days = Math.floor(sec / 86400);
      const hours = Math.floor((sec % 86400) / 3600);
      const mins = Math.floor((sec % 3600) / 60);
      const secs = sec % 60;
      if (this._d) this._d.textContent = this._pad(days);
      if (this._h) this._h.textContent = this._pad(hours);
      if (this._m) this._m.textContent = this._pad(mins);
      if (this._s) this._s.textContent = this._pad(secs);
    }
  }

  customElements.define('edj-landing-countdown', EdjLandingCountdown);
})();
